import React from 'react';
import { AttributeWrapper, IconWrapper } from './styles';
import { Typography } from '@/components/DesignSystem';
import { ReactComponent as EditIcon } from '@/components/Sections/Profile/icons/edit.svg';

interface Props {
    weight: '400' | '600' | '700' | '900';
    text: string;
    color?: string;
    onClick: () => void;
}

const LinkAttribute = ({ weight, onClick, text, color = undefined }: Props) => (
    <AttributeWrapper onClick={onClick}>
        <Typography type="label" size={16} weight={weight} color={color}>
            {text}
        </Typography>
        <IconWrapper>
            <EditIcon />
        </IconWrapper>
    </AttributeWrapper>
);

export default LinkAttribute;
